import { type EChartsExtensionInstallRegisters } from 'echarts/types/src/extension';
import { treemapExtensionInstall } from './treemap';

export function install(registers: EChartsExtensionInstallRegisters) {
  treemapExtensionInstall(registers);
}
